export default "__VITE_ASSET__DM$fKlus__"